module.exports = __webpack_public_path__ + "static/media/homeVideo.f7c35fd0.svg";